import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { TextLoca } from "../generic/text/TextLoca";
export var RewardInfo = function (_a) {
    var children = _a.children, title = _a.title, description = _a.description;
    return (React.createElement("div", { className: "reward-dialog__info" },
        React.createElement("div", { className: "reward-dialog__content " + IdStyles.RewardDialogContentContainer },
            React.createElement("div", { className: IdStyles.TextButtonHeading },
                React.createElement(TextLoca, { id: title })),
            React.createElement("div", { className: "reward-dialog__content-description" },
                React.createElement("div", { className: IdStyles.TextNormal },
                    React.createElement(TextLoca, { id: description })))),
        React.createElement("div", { className: "reward-dialog__rewards " + IdStyles.RewardDialogRewardsContainer }, children)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/pending-inventory/RewardInfo.tsx
// module id = 2856
// module chunks = 3